import styled from "styled-components";
export const CarouselProductWrapper = styled.div.withConfig({
    displayName: "styled__CarouselProductWrapper",
    componentId: "sc-29070ce-0"
})`
	background: ${({ theme  })=>theme.bodyBgColor};
	& > :not(.button-view-more) {
		margin-top: 8px;
	}
`;

//# sourceMappingURL=styled.js.map